import { SearchResultProduct } from 'store/search/types';
import { RESULTS_PER_PAGE } from 'settings';
import { LIST_SEARCH_RESULTS_PAGE } from './gtmSearchProductClickEvent';

const lastPageOffset = (designs: SearchResultProduct[]) =>
  Math.max(Math.round(designs.length / RESULTS_PER_PAGE) - 1, 0) * RESULTS_PER_PAGE;

const gtmSearchResultsEvent = (designs: SearchResultProduct[], firstElementOffset: number, extraParams: any) => {
  const lastPageStartOffset = lastPageOffset(designs);
  return {
    event: 'searchResults',
    ...extraParams,
    ecommerce: {
      products: designs.slice(lastPageStartOffset).map((design, index) => ({
        sku: design.sku,
        position: firstElementOffset + lastPageStartOffset + index,
        productTier: design.productTier,
        productTypeId: design.productTypeId,
        isPersonalised: design.isPersonalised,
        list: LIST_SEARCH_RESULTS_PAGE,
      })),
    },
  };
};

export default gtmSearchResultsEvent;
